import { connect } from 'react-redux';
import { firebase, helpers } from 'redux-react-firebase';
import PrivateRoute from '../../components/routes/private-route';

const { pathToJS } = helpers;

const mapStateToProps = state => ({
  auth: pathToJS(state.firebase, 'auth'),
});

export default firebase()(connect(mapStateToProps)(PrivateRoute));



// WEBPACK FOOTER //
// ./src/containers/routes/private-route.js